import React, { useEffect, useState } from 'react';
import { ServiceName, ServiceValue } from './types';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Button,
    Typography,
    Switch,
    Grid,
} from '@material-ui/core';
import i18n from 'i18n-js';
import clsx from 'clsx';
import { getImageByService } from 'helpers/helperFunctions';
import useStyles from '../styles';

type OnSaveValue = Pick<ServiceValue, 'isDeliverAnytime' | 'isPayToClose'>;

interface Props {
    serviceName: ServiceName;
    service: ServiceValue;
    open: boolean;
    onSave: (value: OnSaveValue) => void;
    onCancel: VoidFunction;
}

export default function ServiceAdditionalSettingsModal({
    serviceName,
    service,
    open,
    onSave,
    onCancel,
}: Props) {
    const classes = useStyles();
    const [isDeliverAnytime, setIsDeliverAnytime] = useState(false);
    const [isPayToClose, setIsPayToClose] = useState(false);

    useEffect(() => {
        if (open) {
            setIsDeliverAnytime(service.isDeliverAnytime);
            setIsPayToClose(service.isPayToClose);
        }
    }, [open])

    function handleClose(event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void {
        onCancel();
    }

    function handleSave(event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void {
        onSave({
            isDeliverAnytime: isDeliverAnytime,
            isPayToClose: isPayToClose,
        });
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            scroll={'paper'}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <DialogTitle>
                <Grid container spacing={1}>
                    <Grid item>{getImageByService(serviceName, classes, service.isActive)}</Grid>
                    <Grid item>{i18n.t('restaurant.serviceWideSettings')}</Grid>
                </Grid>
            </DialogTitle>
            <DialogContent>
                <p>{i18n.t(`restaurant.serviceWideText`, { serviceName: i18n.t(`restaurant.${serviceName}`) })}</p>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <div className={classes.serviceToggleWrapper}>
                            <Grid
                                container
                                alignItems="center"
                                className={clsx(classes.serviceToggleRow, classes.serviceToggleRowDivided)}
                            >
                                <Grid item xs>
                                    <Typography variant="subtitle1">
                                        {i18n.t('restaurant.deliverAnytime')}
                                    </Typography>
                                </Grid>
                                <Grid item xs="auto">
                                    <Switch
                                        checked={isDeliverAnytime}
                                        name="isDeliverAnytime"
                                        color="primary"
                                        onChange={(_, value) => setIsDeliverAnytime(value)}
                                    />
                                </Grid>
                            </Grid>

                            <Grid
                                container
                                alignItems="center"
                                className={classes.serviceToggleRow}
                            >
                                <Grid item xs>
                                    <Typography variant="subtitle1">
                                        {i18n.t('restaurant.payToClose')}
                                    </Typography>
                                </Grid>
                                <Grid item xs="auto">
                                    <Switch
                                        checked={isPayToClose}
                                        name="isPayToClose"
                                        color="primary"
                                        onChange={(_, value) => setIsPayToClose(value)}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                    </Grid>
                </Grid>

                <Grid
                    container
                    justifyContent="flex-end"
                    spacing={2}
                    className={classes.serviceActions}
                >
                    <Grid item>
                        <Button onClick={handleClose} color="primary">
                            {i18n.t('button.cancel')}
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button onClick={handleSave} variant="contained" color="primary">
                            {i18n.t('button.save')}
                        </Button>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
}
